import { ia, iaRa, inRn, pluralize } from 'lib/helpers/utility';

import { showAlert } from 'components/shared/Alert/Alert';

import { getInvoicesFromSelectedRows } from '../../../lib/utils';
import { removeTempIdFromInvoice } from '../components/EditInvoiceModal/lib/tempIdHandler';
import { getProceduresTotal } from '../components/InvoiceFooter/InvoiceSummary/lib/helpers';

export const getAddressDisplay = (address) => {
  if (address && typeof address === 'object' && !ia(address)) {
    return address?.fullAddress;
  }

  if (address && typeof address !== 'number') {
    return address;
  }

  return null;
};

export const getExistingExternalInvoicesMessage = (existingInvoices) => {
  const invoices = iaRa(existingInvoices).flatMap((invoice) => iaRa(invoice.internal_invoice_ids));
  const uniqueInvoices = [...new Set(invoices)];
  const invoiceIds = uniqueInvoices.join(', ');
  return `An external invoice has already been created for one of these invoices.
                  ${pluralize('Invoice', uniqueInvoices.length, 'Invoice Id')}: ${invoiceIds}
                  Creating another invoice may result in duplicates.
                  Do you still want to continue?`;
};

export const getCurrentInvoices = (data) => {
  return iaRa(data)
    .filter((invoice) => invoice.show)
    .map((invoice) => {
      const updatedInvoice = removeTempIdFromInvoice(invoice);

      const procedureTotalData = getProceduresTotal({
        invoices: [updatedInvoice],
        isAEOB: invoice?.aeob ?? true
      });

      return {
        ...updatedInvoice,
        total_amount_cents: inRn(procedureTotalData?.total) + inRn(invoice?.surcharge_amount),
        procedures: updatedInvoice.procedures.filter((procedure) => procedure.show),
        products: updatedInvoice.products.filter((product) => product.show),
        packages: updatedInvoice.packages.filter((pkg) => pkg.show)
      };
    });
};

export const excludeInvoicesHandler = (invoices, existingInvoices, closeConfirmationModal) => {
  const existingInternalIds = iaRa(existingInvoices).flatMap((invoice) =>
    iaRa(invoice.internal_invoice_ids)
  );

  const remainingInternalInvoices = iaRa(invoices).filter(
    (invoice) => !existingInternalIds.includes(invoice.id)
  );

  if (!ia(remainingInternalInvoices)) {
    showAlert({
      title: 'All Invoices Excluded',
      message: 'All selected invoices have already been created. No new invoices will be created.',
      color: 'info',
      variant: 'light'
    });
    closeConfirmationModal();
    return;
  }

  const rebuiltInvoices = getInvoicesFromSelectedRows(remainingInternalInvoices);

  const finalInvoices = iaRa(rebuiltInvoices).map((invoice) => ({
    ...invoice,
    total_amount_cents: inRn(invoice?.total_amount) + inRn(invoice?.surcharge_amount),
    procedures: invoice.procedures.filter((procedure) => procedure.show),
    products: invoice.products.filter((product) => product.show),
    packages: invoice.packages.filter((pkg) => pkg.show)
  }));

  return finalInvoices;
};
